
// thousand delimiters with non-breaking space
export default function(int) {
	return int.toString().replace(/\B(?=(\d{3})+(?!\d))/g, String.fromCharCode(160)).replace('.',',');
}



// WEBPACK FOOTER //
// ./src/delimiter.js